import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

export const insertCSV = async <T extends Record<string, unknown>>({
  query,
  boardId,
  domain,
  fields,
  fileKey,
  headers,
}: FetchRequestArgs & {
  boardId: string;
  fields: unknown;
  fileKey: unknown;
}): Promise<ReturnType<typeof fetchRequest>> =>
  fetchRequest<T>({
    data: {
      fields,
      fileKey,
    },
    domain,
    endpoint: `/csv/insert/${boardId}`,
    headers: {
      ...headers,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      'csv-date-format': true,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      'v2-parse': true,
    },
    method: HTTPMethod.POST,
    query,
  });
